import React, {ChangeEvent, useState} from 'react'
import {isValidEmail, isValidString} from '../../../../../utils';
import {useTranslation} from "react-i18next";
import {ReactComponent as Forward} from '../../../../../assets/icons/forward.svg'
import {Employee} from "../../../../../app/interfaces";
import {IconContainer, ResendSignatureEmailForm} from "./styles";
import api from "../../../../../services/api";
import {InputText, PopupLoading, PopupWithMessage, SecondaryButton} from "../../../../../components";

const ResendSignatureEmail = ({employee}: { employee: Employee }) => {

    const [email, setEmail] = useState<string>('')
    const [emailError, setEmailError] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [fetchError, setFetchError] = useState<string>('')
    const [fetchSuccess, setFetchSuccess] = useState<boolean>(false)
    const {t} = useTranslation()

    const handleSubmit = async () => {
        setIsLoading(true)
        try {
            const response = await api.post(
                `/resend_signature_email/employee/${employee._id}/email/${email}`,
            );
            if(response.data.sent){
                setFetchSuccess(true)
            }
        } catch (e) {
            setFetchError(t('resend_signature_email_error') as string)
        } finally {
            setIsLoading(false)
        }
    }

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setEmail(value)
        setEmailError(!isValidEmail(value) as boolean)
    }

    if (isLoading) {
        return <PopupLoading isOpen={true}/>
    }

    if (isValidString(fetchError)) {
        return <PopupWithMessage
            type="error"
            title={t('error_message_title') as string}
            subtitle={fetchError}
            isOpen={true}
            buttonTitle={'Ok'}
            buttonAction={() => setFetchError('')}
        />
    }

    if (fetchSuccess) {
        return <PopupWithMessage
            type="success"
            title={t("resend_signature_email_success_title") as string}
            subtitle={t("resend_signature_email_success_message") as string}
            buttonTitle={'Ok'}
            isOpen={true}
            buttonAction={() => {
                setFetchSuccess(false)
                setEmail('')
                setEmailError(false)
            }}
        />
    }

    return <ResendSignatureEmailForm onSubmit={handleSubmit}>
        <InputText
            value={email}
            helperText={emailError ? t('invalid_email') as string : ''}
            status={emailError ? 'danger' : 'normal'}
            onChange={(e) => handleInputChange(e)}
        />
        <SecondaryButton type="submit" disabled={emailError || !email}>
            {t('resend_signature_email')}
            <IconContainer>
                <Forward/>
            </IconContainer>
        </SecondaryButton>
    </ResendSignatureEmailForm>
}

export default ResendSignatureEmail;
